import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PackageDetailShared } from '../../../models/interface/packageDetail.interface';
import { Flags } from '../../../types/flags.type';

@Component({
  selector: 'app-mu-modal-rate',
  templateUrl: './mu-modal-rate.component.html',
  styleUrls: ['./mu-modal-rate.component.sass'],
})
export class MuModalRateComponent<FlagType> implements OnInit {
  @Input() packageDetail: PackageDetailShared;
  @Input() formData: UntypedFormGroup;
  @Input() valueField: string;
  @Input() descriptionField: string;
  @Input() starValueList: number[];
  @Input() showFlag: FlagType;
  @Input() actionFlag: FlagType;
  @Input() loaderFlag: FlagType;
  @Input() flagList: Flags<FlagType>;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() subTitleValue: string;
  @Input() message: string;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * get show modal
   */
  get showModalState(): boolean {
    return this.flagList ? this.flagList.get(this.showFlag) : false;
  }
}
